/**
 * Endereços antigos que caem no login unificado. Os logins por perfil foram consolidados no DEV-341. As telas de
 * senha, a de protocolo e o formulário de convênio saíram porque no Portal 2.0 ninguém tem senha: todo mundo entra
 * com o identificador e o código (backend spec 20261021-141500, AC-8 e AC-9). Um link antigo de e-mail ou de favorito
 * chega ao login em vez de cair numa rota que não existe mais.
 */
export const LEGACY_LOGIN_PATHS = [
  "/login/Senne",
  "/login/administrador",
  "/login/hospitalar",
  "/login/operacao",
  "/login/hospital",
  "/login/medico",
  "/login/convenio",
  "/login/protocol",
  "/nova-senha",
  "/reset-password",
] as const;
